import component from './component'

export default {
    path: '/periodoGraduacion',
    name: 'periodoGraduacion',
    component: component
}



// WEBPACK FOOTER //
// ./src/components/graduados/periodoGraduacion/index.js